import axios, { CancelTokenSource } from 'axios'
import { SortDirection } from '../../../../types/sorted-request.dto'
import {
  getCensusFileRows,
  getCensusFileRowTypeCounts,
} from '../../api/census-enrollment-platform-api-client'
import { CensusFileRowStatusEnum } from '../../api/enums/census-file-row-status.enum'
import { CensusFileRowTypeEnum } from '../../api/enums/census-file-row-type.enum'

let cancelSource: CancelTokenSource | null = null

// Get census file and row data and row type counts to populate tabs and tables
// for records that are currently IN_PROCESS
export async function getInReviewPageData({
  limit,
  page,
  publicKey,
  sort,
  order,
  censusRowType,
  censusFileRowStatuses,
  excludeMatch,
  search,
}: {
  limit: number
  page: number
  publicKey: string
  sort?: string
  order?: SortDirection
  censusRowType?: CensusFileRowTypeEnum | CensusFileRowTypeEnum[]
  censusFileRowStatuses: CensusFileRowStatusEnum[]
  excludeMatch?: boolean
  search?: string
}) {
  cancelSource?.cancel()
  cancelSource = axios.CancelToken.source()
  const { token: cancelToken } = cancelSource

  const countQueryTypes: CensusFileRowTypeEnum[] = [
    CensusFileRowTypeEnum.UPDATE_EMPLOYEE_BENEFITS,
    CensusFileRowTypeEnum.UPDATE_EMPLOYEE_NO_BENEFITS,
    CensusFileRowTypeEnum.DRAFT_EMPLOYEE,
    CensusFileRowTypeEnum.ERROR,
    CensusFileRowTypeEnum.DUPLICATE_EMPLOYEE,
    CensusFileRowTypeEnum.UNDETERMINED,
  ]
  const countQueryStatus: CensusFileRowStatusEnum[] = [
    CensusFileRowStatusEnum.IN_REVIEW,
  ]

  const typeParam = Array.isArray(censusRowType)
    ? censusRowType
    : censusRowType
      ? [censusRowType]
      : undefined

  const censusFileRows = getCensusFileRows(
    {
      limit,
      page,
      publicKey,
      sort,
      order,
      type: typeParam as CensusFileRowTypeEnum[],
      status: censusFileRowStatuses as CensusFileRowStatusEnum[],
      excludeMatch,
      search,
    },
    { cancelToken }
  )
  const counts = getCensusFileRowTypeCounts(
    {
      publicKey,
      type: countQueryTypes,
      status: countQueryStatus,
    },
    { cancelToken }
  )
  const [rowResponse, rowCounts] = await Promise.all([censusFileRows, counts])
  const { data, meta: pagination, censusFile, contributionGroups } = rowResponse
  return { rowCounts, data, pagination, censusFile, contributionGroups }
}
